module.exports = __webpack_public_path__ + "static/media/coin_32.e76a7cc0.png";